import React, { useState, useEffect } from 'react';

const COUNTRIES = [
  { dial: '+33',  flag: '🇫🇷', name: 'France',             pattern: '0X XX XX XX XX', maxDigits: 9  },
  { dial: '+32',  flag: '🇧🇪', name: 'Belgique',           pattern: '0XXX XX XX XX',  maxDigits: 9  },
  { dial: '+41',  flag: '🇨🇭', name: 'Suisse',             pattern: '0XX XXX XX XX',  maxDigits: 9  },
  { dial: '+352', flag: '🇱🇺', name: 'Luxembourg',         pattern: 'XXX XXX XXX',    maxDigits: 9  },
  { dial: '+377', flag: '🇲🇨', name: 'Monaco',             pattern: 'XX XX XX XX XX', maxDigits: 10 },
  { dial: '+590', flag: '🇬🇵', name: 'Guadeloupe',         pattern: '0XXX XX XX XX',  maxDigits: 9  },
  { dial: '+596', flag: '🇲🇶', name: 'Martinique',         pattern: '0XXX XX XX XX',  maxDigits: 9  },
  { dial: '+594', flag: '🇬🇫', name: 'Guyane',             pattern: '0XXX XX XX XX',  maxDigits: 9  },
  { dial: '+262', flag: '🇷🇪', name: 'Réunion',            pattern: '0XXX XX XX XX',  maxDigits: 9  },
  { dial: '+687', flag: '🇳🇨', name: 'Nouvelle-Calédonie', pattern: 'XX XX XX',       maxDigits: 6  },
  { dial: '+689', flag: '🇵🇫', name: 'Polynésie fr.',      pattern: 'XX XX XX XX',    maxDigits: 8  },
  { dial: '+212', flag: '🇲🇦', name: 'Maroc',              pattern: '0X XX XX XX XX', maxDigits: 9  },
  { dial: '+213', flag: '🇩🇿', name: 'Algérie',            pattern: '0XXX XX XX XX',  maxDigits: 9  },
  { dial: '+216', flag: '🇹🇳', name: 'Tunisie',            pattern: 'XX XXX XXX',     maxDigits: 8  },
  { dial: '+221', flag: '🇸🇳', name: 'Sénégal',            pattern: 'XX XXX XX XX',   maxDigits: 9  },
  { dial: '+225', flag: '🇨🇮', name: "Côte d'Ivoire",      pattern: 'XX XX XX XX XX', maxDigits: 10 },
  { dial: '+237', flag: '🇨🇲', name: 'Cameroun',           pattern: 'X XXXX XXXX',    maxDigits: 9  },
  { dial: '+1',   flag: '🇺🇸', name: 'Canada / USA',       pattern: '(XXX) XXX-XXXX', maxDigits: 10 },
  { dial: '+44',  flag: '🇬🇧', name: 'Royaume-Uni',        pattern: '0XXXX XXXXXX',   maxDigits: 10 },
  { dial: '+49',  flag: '🇩🇪', name: 'Allemagne',          pattern: '0XXX XXXXXXXX',  maxDigits: 11 },
  { dial: '+34',  flag: '🇪🇸', name: 'Espagne',            pattern: 'XXX XXX XXX',    maxDigits: 9  },
  { dial: '+39',  flag: '🇮🇹', name: 'Italie',             pattern: 'XXX XXX XXXX',   maxDigits: 10 },
  { dial: '+351', flag: '🇵🇹', name: 'Portugal',           pattern: 'XXX XXX XXX',    maxDigits: 9  },
  { dial: '+31',  flag: '🇳🇱', name: 'Pays-Bas',           pattern: '0X XXXXXXXX',    maxDigits: 9  },
  { dial: '+353', flag: '🇮🇪', name: 'Irlande',            pattern: '0XX XXXXXXX',    maxDigits: 9  },
  { dial: '+43',  flag: '🇦🇹', name: 'Autriche',           pattern: '0XXX XXXXXXX',   maxDigits: 10 },
  { dial: '+45',  flag: '🇩🇰', name: 'Danemark',           pattern: 'XX XX XX XX',    maxDigits: 8  },
  { dial: '+46',  flag: '🇸🇪', name: 'Suède',              pattern: '0XX XXX XX XX',  maxDigits: 9  },
  { dial: '+47',  flag: '🇳🇴', name: 'Norvège',            pattern: 'XXX XX XXX',     maxDigits: 8  },
  { dial: '+48',  flag: '🇵🇱', name: 'Pologne',            pattern: 'XXX XXX XXX',    maxDigits: 9  },
  { dial: '+61',  flag: '🇦🇺', name: 'Australie',          pattern: '0X XXXX XXXX',   maxDigits: 9  },
  { dial: '+81',  flag: '🇯🇵', name: 'Japon',              pattern: '0XX XXXX XXXX',  maxDigits: 10 },
  { dial: '+86',  flag: '🇨🇳', name: 'Chine',              pattern: 'XXX XXXX XXXX',  maxDigits: 11 },
  { dial: '+91',  flag: '🇮🇳', name: 'Inde',               pattern: 'XXXXX XXXXX',    maxDigits: 10 },
  { dial: '+971', flag: '🇦🇪', name: 'Émirats arabes',     pattern: 'XX XXX XXXX',    maxDigits: 9  },
  { dial: '+966', flag: '🇸🇦', name: 'Arabie saoudite',    pattern: 'XXX XXX XXXX',   maxDigits: 10 },
];

// Apply a format pattern to raw digits
// X = digit placeholder, other chars = literal separators
function applyFormat(digits, pattern) {
  let result = '';
  let dIdx = 0;
  for (let i = 0; i < pattern.length; i++) {
    if (dIdx >= digits.length) break;
    const ch = pattern[i];
    if (ch === 'X') {
      result += digits[dIdx++];
    } else {
      // Add separator only if there are more Xs after this position
      const xsAfter = (pattern.slice(i + 1).match(/X/g) || []).length;
      if (xsAfter > 0) result += ch;
    }
  }
  return result;
}

function parsePhone(value) {
  if (!value) return { dial: '+33', local: '' };
  const sorted = [...COUNTRIES].sort((a, b) => b.dial.length - a.dial.length);
  for (const c of sorted) {
    if (value.startsWith(c.dial)) {
      const local = value.slice(c.dial.length).replace(/\D/g, '');
      return { dial: c.dial, local };
    }
  }
  // French number with leading 0
  if (value.startsWith('0') && /^\d+$/.test(value)) {
    return { dial: '+33', local: value.slice(1) };
  }
  return { dial: '+33', local: value.replace(/\D/g, '') };
}

function getCountry(dial) {
  return COUNTRIES.find(c => c.dial === dial) || COUNTRIES[0];
}

function getPlaceholder(country) {
  return applyFormat('0'.repeat(country.maxDigits), country.pattern);
}

export default function PhoneInput({ value, onChange, style }) {
  const parsed = parsePhone(value);
  const [dial, setDial] = useState(parsed.dial);
  const [local, setLocal] = useState(parsed.local);

  useEffect(() => {
    const p = parsePhone(value);
    setDial(p.dial);
    setLocal(p.local);
  }, [value]);

  const emit = (newDial, newLocal) => {
    onChange(newLocal ? `${newDial}${newLocal}` : '');
  };

  const country = getCountry(dial);
  const displayValue = local ? applyFormat(local, country.pattern) : '';

  const handleLocalChange = (e) => {
    let digits = e.target.value.replace(/\D/g, '');
    // If pattern has a leading literal '0' and user typed a leading 0, strip it
    if (country.pattern.startsWith('0') && digits.startsWith('0')) {
      digits = digits.slice(1);
    }
    digits = digits.slice(0, country.maxDigits);
    setLocal(digits);
    emit(dial, digits);
  };

  const handleDialChange = (newDial) => {
    setDial(newDial);
    setLocal('');
    emit(newDial, '');
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <select
        value={dial}
        onChange={e => handleDialChange(e.target.value)}
        style={{
          border: '1px solid var(--border)',
          borderRight: 'none',
          borderRadius: '8px 0 0 8px',
          padding: '8px 6px',
          fontSize: 13,
          background: '#f9fafb',
          cursor: 'pointer',
          outline: 'none',
          color: '#374151',
          flexShrink: 0,
          height: 38,
        }}
      >
        {COUNTRIES.map((c, i) => (
          <option key={`${c.dial}-${i}`} value={c.dial}>{c.flag} {c.dial}</option>
        ))}
      </select>
      <input
        type="tel"
        value={displayValue}
        placeholder={getPlaceholder(country)}
        onChange={handleLocalChange}
        style={{
          flex: 1,
          border: '1px solid var(--border)',
          borderRadius: '0 8px 8px 0',
          padding: '8px 12px',
          fontSize: 13,
          outline: 'none',
          background: 'white',
          height: 38,
          minWidth: 0,
          letterSpacing: '0.04em',
          ...style,
        }}
      />
    </div>
  );
}
